// Menu: Abstract

import './index.scss';

export default class MenuAbstract {
    constructor(root) {
        this.root = root;
        this.root.querySelectorAll('a').forEach((a) => {
            a.parentNode.addEventListener('click', (event) => {
                if (!a.contains(event.target)) { a.click(); }
            });
        });
    }
}
